import { type SearchResponse } from '@algolia/client-search';
import { useAppConfig } from '#/config/AppConfigContext';
import { SearchHit } from '#/modules/search/components/Hit/SearchHit';
import { SearchLoadingSectionMockResults } from '#/modules/search/components/Loading/SearchLoadingSectionMockResults';
import { algoliaTrackClick } from '#/utils/algolia/algoliaTrackClick';
import { trackClicked } from '#/utils/analytics/track/trackClicked';

import { type SearchSavedListingsStore } from '#/modules/search/zustand-stores/searchSavedListingsStore';
import type { ApiJob } from '#/modules/listing/jobs/api/types/ApiJob';
import type { ApiVolop } from '#/modules/listing/volops/api/types/ApiVolop';
import type { SearchAlgoliaJobHit } from '#/modules/search/algolia/types/SearchAlgoliaJobHit';
import type { SearchAlgoliaVolopHit } from '#/modules/search/algolia/types/SearchAlgoliaVolopHit';

import { ViewListingPageSidebarSuggestionsHolder } from './ViewListingPageSidebarSuggestions.styled';

type Props = {
  similarListingsResponse:
    | SearchResponse<SearchAlgoliaJobHit>
    | SearchResponse<SearchAlgoliaVolopHit>;
  listing: ApiJob | ApiVolop;
  searchSavedListingsStore: SearchSavedListingsStore;
};

export function ViewListingPageSidebarSuggestionsContents({
  similarListingsResponse,
  listing,
  searchSavedListingsStore,
}: Props) {
  const { appConfig } = useAppConfig();
  return (
    <ViewListingPageSidebarSuggestionsHolder>
      {similarListingsResponse ? (
        similarListingsResponse.hits.map((hit, index) => (
          <SearchHit
            key={hit.objectID}
            hit={hit}
            searchSavedListingsStore={searchSavedListingsStore}
            highlighted={listing.id === hit.objectID}
            trackClick={() => {
              // Position in algolia analytics is 1-indexed
              const hitIndex =
                similarListingsResponse.page &&
                similarListingsResponse.hitsPerPage
                  ? similarListingsResponse.page *
                      similarListingsResponse.hitsPerPage +
                    index +
                    1
                  : 1;

              void algoliaTrackClick({
                queryID: similarListingsResponse.queryID,
                objectID: hit.objectID,
                position: hitIndex,
                appConfig,
              });

              trackClicked('Search Result', {
                org_id: 'orgID' in hit ? hit.orgID : undefined,
                org_type: 'orgType' in hit ? hit.orgType : undefined,
                result_id: hit.objectID,
                result_index: index,
                result_type: hit.type,
              });
            }}
            actions={null}
            application={null}
            showLabel={false}
            promotionType={null}
          />
        ))
      ) : (
        <SearchLoadingSectionMockResults items={3} />
      )}
    </ViewListingPageSidebarSuggestionsHolder>
  );
}
